function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "wPisDl.tif"
}, React.createElement("g", null, React.createElement("path", {
  d: "M83.1,150c0-1.3,0-2.5,0-3.5c0-19.2,0-38.2,0-57.3c0-2.2,0.2-4.4,0.5-6.6c0.8-5.5,5.2-9.9,10.8-10.6 c2.9-0.3,5.7-0.3,8.6,0c5.2,0.8,9.1,3.9,10.4,9.2c0.5,2.2,0.8,4.5,0.8,6.7c0,19.7,0,39.2,0,58.9c0,1,0,2,0,3.2 c10.8,0,21.2,0,31.8,0c0-0.7,0.2-1.2,0.2-1.5c-0.2-23.2-0.2-46.4-0.7-69.6c-0.2-6.4-1.7-12.8-3.5-19c-2.9-9.4-8.9-15.8-18.5-18.8 c-6.6-2-13.5-2-20.2-1.3c-8.7,0.8-16.6,3.2-20.3,12.6c0-4.2,0-8.4,0-12.6c-10.8,0-21.2,0-31.4,0c0,37,0,73.7,0,110.3 C62.1,150,72.3,150,83.1,150z M4,39.5C4,76.3,4,113.2,4,150c10.6,0,21,0,31.6,0c0-36.8,0-73.7,0-110.5C25.1,39.5,14.6,39.5,4,39.5 z M3.9,15.8c0,9.2,6.9,16.1,15.8,16.1c9.1,0,16-6.9,16.1-15.6C35.8,7.1,29.1,0,20,0C10.9,0,3.9,6.7,3.9,15.8z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      "enableBackground": "new 0 0 150 150"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/linkedin.6bbbbadf.svg";
export { SvgComponent as ReactComponent };